import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { DB_User } from '../../../interfaces/user';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { openSnackBar } from '../../../helpers/genericFunctions';

/**
 * component to create a new user. New users are by default not active and can't do anything. they have to be authenticated by support staff.
 */
@Component({
  selector: 'app-create-new-user',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatToolbarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgIf,
  ],
  templateUrl: './register-user.component.html',
  styleUrl: './register-user.component.scss',
})
export class RegisterUserComponent {
  /**
   * constructor
   *
   * @param formBuilder form builder for user form
   * @param router angular routing
   * @param loginService login api service to push new user to db
   * @param snackBar overlay for displaying error and success messages
   */
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
  ) {}

  /**
   * handles laoding wheel element showing
   */
  loggingIn = false;

  /**
   * toggles state of password view
   */
  hidePassword = true;

  /**
   *
   */
  inviteToken: string = '';

  /**
   * form to add a new user to the db
   *
   * @param usr_NAME new user name. Has ti be unique
   * @param usr_PASSWORD password a user chooses
   * @param usr_MAIL email to contact the user
   */
  createUserForm = this.formBuilder.group({
    usr_NAME: new FormControl('', Validators.required),
    usr_PASSWORD: new FormControl('', Validators.required),
    usr_MAIL: new FormControl('', Validators.required),
  });

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.router.navigate(['/login']); // no token = no access
      return;
    }
    this.inviteToken = token;

    // Optionally decode to pre-fill email (it's not sensitive)
    const payload = JSON.parse(atob(token.split('.')[1]));
    this.createUserForm.patchValue({ usr_MAIL: payload.email });
    this.createUserForm.get('usr_MAIL')?.disable(); // email is fixed by the invite
  }
  /**
   * creates a new account with default (minimal) access_level
   */
  onCreateAccount() {
  this.loggingIn = true;
  const raw = this.createUserForm.getRawValue();

  this.loginService
    .completeRegistration(this.inviteToken, raw.usr_NAME ?? '', raw.usr_PASSWORD ?? '')
    .subscribe(
      (response) => {
        this.loggingIn = false;
        openSnackBar('Account created. You can now log in.', 5000, this.snackBar);
        this.router.navigate(['/login']);
      },
      (error) => {
        openSnackBar(error.error, 5000, this.snackBar);
        this.loggingIn = false;
      },
    );
}
}
